"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function write(buffer, value) {
    const base = new ArrayBuffer(8);
    const view = new DataView(base);
    view.setFloat64(0, value);
    const result = (new Uint8Array(base)).reverse();
    buffer.set(result, 0);
}
exports.write = write;
//# sourceMappingURL=ieee754.js.map